<template>
	
	<div class="ui grid">
		<div class="ui row stackable recordings-row">
			<div class="four wide column">
				<div class="ui vertical fluid menu" v-if="groups">
					<div class="item" v-for="item in groups"  >
						<a class="dz-link" v-on:click="getRecordings(item)" :class="{'active teal': item == currentGroup}">
							{{item.title}} <br>
							<small>{{item.subtitle}}</small>
						</a>
					</div>
				</div>
			</div>
			<div class="twelve wide column" v-if="loading">
				<div class="ui segment">
					<div class="ui active centered inline loader"></div>
				</div>
			</div>
			<div class="twelve wide column" v-else id="sticky-context">
				<div class="ui top attached sticky segment">
					<div class="ui grid stackable">
						<div class="eight wide column">
							<h2 class="ui header">
								{{title}} 
								<div class="sub header">{{subtitle}}</div>
							</h2>
						</div>
						<div class="eight wide column">
							<div class="multi-player">
								<div class="d-flex vertical-center">
									<i class="volume up icon"></i>
									<div class="flex-stretch">
										<vue-slider ref="volume-slider" v-model="volume" class="slider" :tooltip="false" :max="1" :interval="0.01"></vue-slider>
									</div>
									<div class="ui buttons">
										<button class="ui icon loading button" v-if="isLoading()">
											<i class="play icon hidden"></i>
										</button>
										<button class="ui icon button" v-if="!isLoading() && !isPlaying()" v-on:click="playAudio()">
											<i class="play icon"></i>
										</button>
										<button class="ui icon active button" v-if="isPlaying()" v-on:click="pauseAudio()" >
											<i class="pause icon"></i>
										</button>
										<button class="ui icon button" v-on:click="playPrevious()" v-bind:class="{'disabled': !isPlaying()}">
											<i class="step backward icon"></i>
										</button>
										<button class="ui icon button" v-on:click="playNext()" v-bind:class="{'disabled': !isPlaying()}">
											<i class="step forward icon"></i>
										</button>
										<button class="ui icon button" v-on:click="setPlayQueue()" v-bind:class="{'active': playQueue}" title="Samodejno predvajanje">
											<i class="sync icon"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ui attached segment playlist-wrap">
			 		<table class="ui celled table">
						<thead>
							<tr>
								<th><span class="number-full">Številka</span><span class="number-abbreviated">Št.</span></th>
								<th v-for="header in headers">{{header}}</th>
								<th>Dolžina</th>
							</tr>
						</thead>
						<tbody>
							<tr :class="`download-row ${downloadBtnVisible ? 'show' : ''}`">
								<td class="download-column">
									<input class="checkall-chkbox" type="checkbox" v-model="checkAllAudios" @click="toggleCheckboxes">
								</td>
								<td class="download-column">
									<button :class="`download-button ${preneseneDatoteke == null ? '' : 'loading'}`" @click="prenesiIzbraneMp3">
										<span v-cloak>{{ preneseneDatoteke == null ? 'Prenesi' : 'Prekini'}}</span>
									</button>
								</td>
								<td class="download-column">
									<span class="download-details" v-cloak>{{ preneseneDatoteke ? `${preneseneDatoteke} / ${checkedAudios.length} ${izbranihDatotek}` : `${checkedAudios.length} ${izbranihDatotek}`}}</span>
								</td>
							</tr>
							<tr v-for="(item, index) in audios" v-bind:class="{'active': item == audio}">
								<td class="first-column">
									<span>{{item.number}}</span>
									<input :class="`download-chkbox${checkedAudios.filter(myItem => myItem.number === item.number).length > 0 ? ' checked' : ''}`" type="checkbox" :value="item" v-model="checkedAudios" @click="selectCheckboxesInBetween(item.number)" @keydown.16="rememberKeyDown(item.number)">
								</td>
								<td v-for="(header, key) in headers">{{item[key]}}</td>
								<td>
									<div class="single-player">
										<div class="d-flex vertical-center">
											<button class="ui icon loading button" v-if="isLoading(item)">
												<i class="play icon hidden"></i>
											</button>
											<button class="ui icon button" v-if="!isLoading(item) && !isPlaying(item)" v-on:click="playAudio(item)">
												<i class="play icon"></i>
											</button>
											<button class="ui icon active button" v-if="isPlaying(item)" v-on:click="pauseAudio()">
												<i class="pause icon"></i>
											</button>
											<vue-slider ref="sliders" v-model="singleSliders[index]" class="slider flex-stretch" :tooltip="false" :max="toSeconds(item.duration)" :interval="0.01" :disabled="!isPlaying(item)" @drag-start="dragStart" @drag-end="dragEnd(index)" :speed="0"></vue-slider>
											<span>{{item.seek | seek}} / {{item.duration}}</span>
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="ui bottom attached segment">
					<div class="body" v-html="body"></div>
				</div>
			</div>
		</div>
		<div :class="`recordings-popup-overlay ${popup.visibility}`" @click.stop="closePopup">
			<div class="recordings-popup" @click.stop="() => {}">
				<img class="logo" src="images/header-logo.svg" alt="iRokus logotip">
				<h4 v-html="popup.title" v-cloak></h4>
				<div class="recording-popup-btncontainer">
					<button class="confirm" @click="popupConfirmMethod">{{ popup.confirmText }}</button>
					<button class="cancel" @click="closePopup">Prekliči</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vueSlider from "vue-slider-component";
import {Howl, Howler} from 'howler';

export default {
	components: {
		vueSlider
	},
	props: ["user"],
	data() {
		return {
			groups: undefined,
			currentGroup: undefined,
			currentGroupAudios: undefined,
			downloadAudiosSelected: undefined,
			audio: undefined,
			loading: true,
			singleSliders: [],
			mainSlider: 0,
			volume: 0,
			sound: undefined,
			state: 'stopped',
			playQueue: false,
			seeking: false,
			// popup
			popup: {
				visibility: "",
				title: "",
				confirmText: "Vredu"
			},
			popupConfirmMethod: () => {},
			// checkboxes
			checkedAudios: [],
			checkAllAudios: false,
			preneseneDatoteke: undefined,
			downloadProblem: false,
			prekinitevPrenosa: false,
			selectCheckboxesFrom: undefined
		};
	},
	mounted() {
		this.getGroups();
		this.volume = Howler.volume();
		$('.ui.sticky').sticky({
			context: '#sticky-context',
			offset: 50,
		});
	},
	methods: {
		getGroups() {
			this.loading = true;
			axios.get(this.route('posnetki')).then(response => {
				this.groups = response.data.items;
				if (localStorage.lastRecordingGroup) {
					this.getRecordings(
						_.find(this.groups, { slug: localStorage.lastRecordingGroup })
					);
				} else {
					this.getRecordings(this.groups[0]);
				}
			});
		},
		rememberKeyDown(itemNr) {
			this.selectCheckboxesFrom = itemNr;
		},
		toggleCheckboxes() {
			if (this.checkAllAudios) {
				this.checkedAudios = [];
			} else {
				this.checkedAudios = this.currentGroupAudios ? this.currentGroupAudios.audio : [];
			}
		},
		closePopup(e) {
			this.popupConfirmMethod = () => {};
			return this.popup = {
				visibility: "",
				title: this.popup.title,
				confirmText: this.popup.confirmText
			}
		},
		selectCheckboxesInBetween(itemNr) {
			if (this.selectCheckboxesFrom == null) {
				return;
			}
			if (this.selectCheckboxesFrom < itemNr) {
				const mozniDuplikati = this.currentGroupAudios ? this.checkedAudios.concat(this.currentGroupAudios.audio.filter(item => item.number >= this.selectCheckboxesFrom && item.number <= itemNr)): [];
				this.checkedAudios = this.removeDuplicates(mozniDuplikati);
			} else {
				const mozniDuplikati = this.currentGroupAudios ? this.checkedAudios.concat(this.currentGroupAudios.audio.filter(item => item.number <= this.selectCheckboxesFrom && item.number >= itemNr)): [];
				this.checkedAudios = this.removeDuplicates(mozniDuplikati);
			}
			this.selectCheckboxesFrom = undefined;
		},
		removeDuplicates(arr) {
				const seen = {};
				return arr.filter(audio => {
					return seen.hasOwnProperty(audio.number) ? false : (seen[audio.number] = true);
				});
		},
		resetAfterDownloadStarted() {
			this.preneseneDatoteke = undefined;
			this.prekinitevPrenosa = true;

		},
		async prenesiIzbraneMp3() {
			if (this.preneseneDatoteke != null) {// v primeru klika (prekinitve) med prenosom
				return this.resetAfterDownloadStarted();
			}
			if (this.user == null) { // če ni prijavljen
				this.popupConfirmMethod = () => window.location.href = '/login';
				return this.popup = {
					visibility: "visible",
					title: "Za prenos datotek je potrebno biti prijavljen.",
					confirmText: "Na prijavo"
				}
			}
			
			const workbook = this.currentGroup;
			const zip = new this.JSZip();
			const zipFolder = zip.folder(workbook.slug);
			this.preneseneDatoteke = 0;
			let preneseneDatoteke = 0;
			const vsehDatotekZaPrenos = this.checkedAudios.length;
			for(let i = 0; i < vsehDatotekZaPrenos; i++) {
				const audioNr = this.checkedAudios[i].number;
				const audioFile = this.checkedAudios[i].file;
				const lesson = this.checkedAudios[i].lession;
				if (this.prekinitevPrenosa) {
					break; // ob prekinitvi preprečimo nadaljne prenose, ki so sinhroni zaradi await operatorja
				}
				await axios.get(this.route('posnetki-download', workbook.slug, audioNr), { responseType: 'blob' })
					.then(async response2 => {
						if (response2.status === 200) {
							const fileData = response2.data || "";
							const blob = new Blob([fileData], { type: 'audio/mpeg' });
							zipFolder.file(`${lesson} - ${audioFile}`, blob);
							this.preneseneDatoteke = ++preneseneDatoteke;
							this.downloadProblem = false;
						} else if (response2.status === 210) {
							this.popupConfirmMethod = this.closePopup;
							this.downloadProblem = true;
							const title = await response2.data.text();
							return this.popup = {
								visibility: "visible",
								title: title,
								confirmText: "V redu"
							};
						} else if (response2.status === 211) {
							this.popupConfirmMethod = () => window.location.href = '/login';
							this.downloadProblem = true;
							return this.popup = {
								visibility: "visible",
								title: "Za prenos datotek je potrebno biti prijavljen.",
								confirmText: "Na prijavo"
							};
						} else {
							this.popupConfirmMethod = this.closePopup;
							this.downloadProblem = true;
							return this.popup = {
								visibility: "visible",
								title: "Prišlo je do napake pri prenosu. Prosim poskusite kasneje oz. se obrnite na <a href='https://www.podpora.rokus-klett.si'>podpora.rokus-klett.si</a>",
								confirmText: "V redu"
							};
						}
					})
					.catch(reason => {
						this.popupConfirmMethod = this.closePopup;
						this.downloadProblem = true;
						return this.popup = {
							visibility: "visible",
							title: "Prišlo je do napake pri prenosu. Prosim poskusite kasneje oz. se obrnite na <a href='https://www.podpora.rokus-klett.si'>podpora.rokus-klett.si</a>",
							confirmText: "V redu"
						}
					});
			}

			// shranimo zazipano mapo, če ni bil prenos prekinjen ali če ni prišlo do problemov (blokada porenosa ali network / server error)
			if (!this.downloadProblem && !this.prekinitevPrenosa) {
				zip.generateAsync({type:"blob"})
					.then(content => {
						saveAs(content, workbook.slug);
					});
			}
			// ob koncu prenosa počistimo spremenljivke, ki vplivajo na proces downloada
			this.prekinitevPrenosa = false;
			this.preneseneDatoteke = undefined;
			return;
		},
		
		getRecordings(group) {
			this.checkedAudios = [];
			this.stopAudio();
			this.currentGroup = group;
			this.loading = true;
			axios.get(this.route('posnetki', this.currentGroup.slug)).then(response => {
				this.currentGroupAudios = response.data;
				this.singleSliders = [];
				for(let i = 0; i < this.currentGroupAudios.audio.length; i++) {
					let audio = this.currentGroupAudios.audio[i];
					this.$set(audio, 'seek', 0);
					this.singleSliders[i] = 0;
				}
				localStorage.setItem('lastRecordingGroup', this.currentGroup.slug);
				this.loading = false;
				this.$nextTick(() => {
					$('.ui.sticky').sticky('refresh');
				});
			});
		},
		playAudio(audio) {

			if (this.state == 'playing' || (this.audio != undefined && this.audio != audio && audio != undefined)) {
				this.stopAudio();
				this.$nextTick(() => {
					this.playAudio(audio);
				});
				return;
			}

			if (this.state == 'paused') {
				this.state = 'playing';
				return;
			}

			if (audio == undefined) {
				audio = this.audios[0];
				this.setPlayQueue(true);
			}

			this.audio = audio;
			this.state = 'loading';
			
			this.sound = new Howl({
				src: [this.route('posnetki', this.currentGroup.slug, this.audio.number)],
				format: ['mp3']
			});

			this.sound.once('load', () => {
				this.state = 'playing';
			});
			this.sound.once('end', () => {
				if (this.playQueue) {
					this.playNext();
				} else {
					this.stopAudio();
				}
			});
		},
		stopAudio() {
			this.resetSliders();
			if (this.sound) {
				this.sound.unload();
				this.sound = undefined;
			}
			if (this.audio) {
				this.audio.seek = 0;
				this.audio = undefined;
			}
			this.state = 'stopped';
		},
		pauseAudio() {
			this.state = 'paused';
		},
		isPlaying(audio) {
			return this.isState('playing', audio);
		},
		isLoading(audio) {
			return this.isState('loading', audio);
		},
		isPaused(audio) {
			return this.isState('paused', audio);
		},
		isState(state, audio) {
			if (audio) {
				return this.state == state && this.audio == audio;
			} else {
				return this.state == state;
			}
		},
		setPlayQueue(value) {
			if (value) {
				this.playQueue = value;
			} else {
				this.playQueue = !this.playQueue;
			}
		},
		updateSeek() {
			if (this.sound && this.audio) {
				this.audio.seek = this.sound.seek() || 0;

				if (!this.seeking) {
					let index = this.audios.indexOf(this.audio);
					this.singleSliders[index] = Math.min(this.audio.seek, this.toSeconds(this.audio.duration));
				}
				
			}
			if (this.state == 'playing') requestAnimationFrame(this.updateSeek)
		},
		playPrevious() {
			if (this.audio) {
				let index = this.audios.indexOf(this.audio) - 1;
				if (index < 0) {
					index = this.currentGroupAudios.audio.length - 1;
				}
				this.playAudio(this.audios[index]);
			}
		},
		playNext() {
			if (this.audio) {
				let index = this.audios.indexOf(this.audio) + 1;
				if (index >= this.currentGroupAudios.audio.length) {
					index = 0;
				}
				this.playAudio(this.audios[index]);
			}
		},
		toSeconds(time) {
			let split = time.split(':');
			return parseInt(split[0]) * 60 + parseInt(split[1]);
		},
		resetSliders() {
			for (let i = 0; i < this.audios.length; i++) {
				this.singleSliders[i] = 0;
			}
		},
		dragStart() {
			this.seeking = true;
		},
		dragEnd(index) {
			this.seeking = false;
			this.sound.seek(this.singleSliders[index]);
		}
	},
	watch: {
		volume() {
			Howler.volume(this.volume);
		},
		state() {
			switch (this.state) {

				case 'playing':
					this.sound.play();
					requestAnimationFrame(this.updateSeek);
					break;
				case 'stopped':

					break;
				case 'paused':
					this.sound.pause();

					break;
				case 'loading':

					break;
			}

		}
	},
	computed: {
		body() {
			return this.currentGroupAudios ? this.currentGroupAudios.body : '';
		},
		audios() {
			return this.currentGroupAudios ? this.currentGroupAudios.audio : [];
		},
		title() {
			return this.currentGroupAudios ? this.currentGroupAudios.title : '';
		},
		subtitle() {
			return this.currentGroupAudios ? this.currentGroupAudios.subtitle : '';
		},
		headers() {
			return this.currentGroupAudios ? this.currentGroupAudios.headers : [];
		},
		downloadBtnVisible() {
			return this.checkedAudios.length > 0;
		},
		izbranihDatotek() {
			switch (this.checkedAudios.length) {
				case 1:
					return "izbrana datoteka";
				case 2:
					return "izbrani datoteki";
				case 3:
					return "izbrane datoteke";
				case 4:
					return "izbrane datoteke";
				default:
					return "izbranih datotek";
			}

		}
	},
	filters: {
		seek: function (value) {
			value = Math.round(isNaN(value) ? 0 : value);
			let min = Math.floor(value / 60);
			let sec = value % 60;
			return min + ':' + ('0' + sec).slice(-2);
		}
	}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Recordings.vue